import { Body1, Body1Strong, Link } from '@fluentui/react-components';
import { DateLabel } from '@shared/components/dates/DateLabel';
import { TERMINOLOGY } from '@shared/i18n/terminology';
import useProjectStagesStore from '../stores/useProjectStagesStore';
import type { TStage } from '../types';
import StageStatusBadge from './StageStatusBadge';

const StageDates = ({ startDate, endDate }: Pick<TStage, 'startDate' | 'endDate'>) => {
  if (startDate && endDate)
    return (
      <>
        <DateLabel short>{startDate}</DateLabel> - <DateLabel short>{endDate}</DateLabel>
      </>
    );
  if (startDate)
    return (
      <>
        From <DateLabel short>{startDate}</DateLabel>
      </>
    );
  if (endDate)
    return (
      <>
        Until <DateLabel short>{endDate}</DateLabel>
      </>
    );
  return null;
};

type TProps = {
  projectId: string;
  /** Without a stage, the header of the tasks no stage lists. */
  stage?: TStage;
  count: number;
};

const StageSectionHeader = ({ projectId, stage, count }: TProps) => {
  const setStageDialogState = useProjectStagesStore((state) => state.setStageDialogState);
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-1">
      {stage ? (
        <>
          <Link
            as="button"
            appearance="subtle"
            className="!font-semibold"
            onClick={() => setStageDialogState({ isOpen: true, projectId, stageIndex: stage.index })}
          >
            {stage.title}
          </Link>
          <StageStatusBadge status={stage.status} />
          {(stage.startDate || stage.endDate) && (
            <Body1 className="text-neutralFg-3">
              <StageDates startDate={stage.startDate} endDate={stage.endDate} />
            </Body1>
          )}
        </>
      ) : (
        <Body1Strong>Other {TERMINOLOGY.task.lowerPlural}</Body1Strong>
      )}
      <Body1 className="text-neutralFg-3">
        {count} {count === 1 ? TERMINOLOGY.task.lower : TERMINOLOGY.task.lowerPlural}
      </Body1>
    </div>
  );
};

export default StageSectionHeader;
